define('GamedayScaffoldBootstrap',['require','exports','module','../src/js/GamedayScaffold'],function(require,exports,module){
    return require('../src/js/GamedayScaffold');
});
